module.exports = __webpack_public_path__ + "static/media/soc_FB.1208354e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soc_FB.svg
// module id = 385
// module chunks = 0